export class AccessToken {
  private _type: string;
  private _value : string;


  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }

  get value(): string {
    return this._value;
  }

  set value(value: string) {
    this._value = value;
  }

  public toString() : string{
    return `${this.type} ${this.value}`;
  }
}



// WEBPACK FOOTER //
// ../../src/lib/access-token.ts